import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';

import { openSnackbar } from 'main/store/common/reducer';
import { clearContact } from 'main/store/contact/reducer';
import { selectContactValues } from 'main/store/contact/selectors';
import { schema } from 'main/store/contact/state';
import { callRestAPI, sendContact } from 'main/utils/rest-apis';

export const SendButton = () => {
    const dispatch = useDispatch();
    const values = useSelector(selectContactValues);

    const disabled = useMemo(() => {
        return !schema.isValidSync(values);
    }, [values]);

    const handleClick = useCallback(async () => {
        await callRestAPI(
            dispatch,
            async () => {
                await sendContact(values);
                dispatch(clearContact());
            },
            () => dispatch(openSnackbar({
                severity: 'success',
                message: '問い合わせを受け付けました'
            })),
            () => dispatch(openSnackbar({
                severity: 'error',
                message: 'エラーが発生しました'
            }))
        );
    }, [values, dispatch]);

    return (
        <Button data-testid="contact-send-button" variant="contained" disabled={disabled} onClick={handleClick}>
            送信する
        </Button>
    )
}
